import { useEffect, useState } from "react";
import { useApp } from "../../../context/AppContext";
import { useParams } from "react-router-dom";

//import resources
import { RiShoppingCartLine } from "react-icons/ri";

//import tags
import { Link } from "react-router-dom";


export default function CartDropdown() {

    //get locale
    const { locale } = useParams();

    //get cart
    const { toCart } = useApp();

    const [count, setCount] = useState(0);

    useEffect(() => {
        setCount(Object.keys(toCart?.products || {}).length);
    }, [toCart]);


    return (
        <Link to={`/${locale}/cart`} className="flex items-center rounded-3xl bg-[#e5e7eb] px-4 lg:px-5 h-[50px] right-0 me-0.5 top-0 mt-[3px] text-black text-[20px] relative">
            <div className="absolute top-0 right-0 bg-[var(--orange)] w-[28px] h-[28px] mt-[-8px] me-[-10px] flex items-center justify-center rounded-full text-white text-[11px]">{count}</div>
            <RiShoppingCartLine />
        </Link>
    );
}